import * as actionTypes from './actionTypes'

export const languageTest = (state = {
  isFetching: false,
  isSubmiting: false,
  error: null,
}, action) => {
  switch (action.type) {
    case actionTypes.LANG_TEST_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case actionTypes.LANG_TEST_RECEIVE:
      return {
        ...state,
        ...action.data,
        isFetching: false,
      };
    case actionTypes.LANG_TEST_ERROR:
      return {
        ...state,
        didInvalidate: false,
        error: action.error,
      };
    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/store/languageTest/reducers.js